// import DefaultPage from '../../Components/DefaultPage';


import React, { useState, useRef, useEffect } from 'react'
import axios from 'axios';
import { useLocation, useParams } from "react-router-dom";
import FooterCus from '../../Components/FooterCus';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space, Table } from 'antd';
import Highlighter from 'react-highlight-words';
import pdf from "../../Assets/images/pdf.png";
import RightSidebarGlobal from '../../Components/RightSidebarGlobal';
import { BASE_URL } from "../../routes/config";
import Loader from '../../Components/Loader';
import { TenderPDFFolder } from '../../routes/addresses';
import useFetchTenderNotice from '../../Hooks/API/useFetchTenderNotice';

function TendersPage() {
  const { getPageData, loading } = useFetchTenderNotice('/Wapi/tenderlst');

 

  // const fetchdata = ()=>{
  //   axios.post(`${BASE_URL}/Wapi/tenderlst`,
  //   {
  //     auth_key:"xxxxx",
  //   }
  //   // ,
  //   // {
  //   //     headers: {
  //   //         Authorization: loginData.token,
  //   //     },
  //   // }
  //   ).then(res => {

  //     if(res.status == '200'){
  //       // console.log(res, 'ffffffff', res.data.suc);
        
  //       if(res.data.suc > 0){
  //         setPageData(res?.data?.msg);
  //         setLoading(false);
  //         // console.log(res , 'uuuuuuuuuuuuuuuuuuuuuu', res?.data?.msg);
  //       } else {
  //         setPageData([0])
  //         // pageDataCheck = res.data.status;
  //       }
  
  //       }

  //   }) 

  //  }


  

  const columns = [
    {
      title: 'Name',
      dataIndex: 'subject',
      key: 'subject',
      width: '70%',
      // ...getColumnSearchProps('subject'),
    },
    {
      title: 'Download',
      dataIndex: 'file_name',
      key: 'file_name',
      width: '30%',
     //  ...getColumnSearchProps('document'),
     render: (document) => <a href={BASE_URL +'/'+ TenderPDFFolder + document} className='docDownload' target='_blank'>
       <i class="fa fa-download" aria-hidden="true"></i> Download</a>,
    }
  ];

   useEffect(()=>{
    // fetchdata();
   },[])

  return (
    <>
    <div class="wrapper">
    <div class="inner_page_Sec">
    <div class="col-sm-8 float-left left_sec searchPageTop">

    <h1>Tender</h1>

    {loading ?(
      <Loader align = {'center'} gap = {'middle'} size = {'large'} />
    ):(
      <>
    <Table columns={columns} dataSource={getPageData} scroll={{
        x: 'max-content',
      }} />
      </>
    )}


    
     </div>
     <div class="col-sm-4 float-left">
      <RightSidebarGlobal/>
    </div>

    </div>
    </div>

      {/* <DefaultPage pageTitle={pageContentData.pageTitle} pageContent = {pageContentData.pageContent} /> */}

      {/* <FooterCus/> */}

    </>
  )
}

export default TendersPage